/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { Address, RoutingService } from '@lm-nx-frontend/lm-inf-core';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { CurrentItemService } from '../../../../shared/current-item.service';
import {OrgUnitService} from "../../../../../core/services";
import {ROUTE_PARAMS} from "../../../../../root/route-params";

@Injectable({
  providedIn: 'root',
})
export class CurrentUnitAddressService extends CurrentItemService<Address> {
  // override item$ as we need to use the unit code as well
  readonly item$: Observable<Address | undefined> = this.b2bUnit$.pipe(
    filter((unitUid) => Boolean(unitUid)),
    switchMap((unitUid) =>
      this.key$.pipe(switchMap((code: string) => this.getItem(unitUid, code)))
    )
  );

  constructor(
    protected routingService: RoutingService,
    protected unitService: OrgUnitService
  ) {
    super(routingService);
  }

  getDetailsRoute(): string {
    return 'orgUnitAddressDetails';
  }

  protected getParamKey() {
    return ROUTE_PARAMS.addressCode;
  }

  protected getItem(
    unitUid: string,
    addressId: string
  ): Observable<Address | undefined> {
    return addressId
      ? this.unitService.getAddress(unitUid, addressId)
      : of(undefined);
  }

  getError(code: string): Observable<boolean> {
    return this.unitService.getErrorState(code);
  }
}
